<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
   
    <!-- 头部背景图 -->
    <div class="top_bg">
      <div class="container_box"></div>
    </div>
    <div style="width: 100%;height: 474px; position: absolute;top: 698px;">
      <div class="float_container">
        <div class="des">
          <img :src="des" alt style="width:100%;height: 100%;" />
        </div>
        <div class="float_text">
          <div class="introdution">公司介绍</div>
          <div class="introdution_detail">
            广州市御韵软件有限公司（简称“御韵软件”），成立于2013年，注册资本10000000元人民币。找美网隶属于御韵软件，公司拥有一支成熟的软件开发团队，一直致力于美业管理软件的设计和开发，不断钻研国内外美业管理行业的技术，融合现代化互联网云概念，并结合董事长.王小军先生自身近20年的美业经验，一直不断创新、不断完善，才造就了今日的“找美网”。
          </div>
        </div>
      </div>
    </div>

    <!-- 公司团队 -->
    <div class="temp">
      <div>
        <!-- <div class="temp1">ZHAOMEIW</div>
        <div class="temp2">公司高层团队</div> -->
        <div class="temp1"></div>
        <div class="temp2"></div>
      </div>
      <div class="temp3"></div>
    </div>

    <!-- <div class="lead">
      <div class="lead_box1">
        <div class style="width: 576px;height: 369px;">
          <img :src="boss" alt style="width: 100%;height: 100%;" />
        </div>
        <div style="margin-top: 24px;display: flex;align-items: flex-end;">
          <div class="boss_name">王小军</div>
          <div class="duty">(董事长/创始人)</div>
        </div>
        <div style="margin-top: 30px;">
          <span class="job">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：</span>
          <span class="job_name">企业家、慈善家</span>
        </div>
        <div class="good_name">
          <div class="job">个人荣誉：</div>
          <div class="honors">六安市文明办六安好人荣誉称号、共青团六安市委第五届“六安青年五四奖章”获得者、雷锋星、2017年度广东省厚德精准扶贫助学特别贡献奖。</div>
        </div>
        <div class="good_name">
          <div class="job">人生格言：</div>
          <div class="mottos">言必践，行必果，信为安身立命之本。</div>
        </div>
        <div class="good_name">
          <div class="job">个人简介：</div>
          <div class="person_con">
            在2011年创立“御玫瑰健康美肤”，成为广州最有影响力的美容连锁之一,
            御玫瑰在全国已拥有了60家直营店；2015年12月创立的“广州市御韵软件有限公
            司”，于2018年5月在香港成功挂牌，股权代码；HK.10065。引领企业发展的
            同时，十年来一直默默投身于公益慈善，为企业树立了正确的价值观，给团队带
            出了正确的人生观！用行动诠释“聚世间诚善，御天下之美”为使命！
          </div>
        </div>
      </div>
      <div class="lead_box2" style="margin-left: 48px;">
        <div class style="width: 576px;height: 369px;">
          <img :src="leader" alt style="width: 100%;height: 100%;" />
        </div>
        <div style="margin-top: 24px;display: flex;align-items: flex-end;">
          <div class="boss_name">杨妙雨</div>
          <div class="duty">(总裁/联合创始人)</div>
        </div>
        <div style="margin-top: 30px;">
          <span class="job">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;业：</span>
          <span class="job_name">企业家、美业管理咨询师、金牌讲师</span>
        </div>
        <div class="good_name">
          <div class="job">人生格言：</div>
          <div class="mottos">不忘初心，方得始终。</div>
        </div>
        <div class="good_name">
          <div class="job">个人简介：</div>
          <div class="person_con">
            毕业于四川成都大学，毕业后加入中国顶尖咨询管理公司“聚成”,2014年创业
            成立“成都财亨商贸”，并运营“四川大爱者联盟”。2015年任职广州御韵软
            件有限公司总裁，致力于美业SAAS体系运营和推广，截止2019年覆盖美业门店
            近10000家。自创立“找美网”以来，一路风雨兼程，致力于美业发展，只为提
            供安全的美业SaaS云服务系统，及专业的美业产业链综合性平台；一直秉承着
            “创新升级每一套系统，用心服务每一个客户”的服务理念，势必要开创美业新
            时代、共筑美业生态链。
          </div>
        </div>
      </div>
    </div> -->
    <!-- 联系我们1 -->
    <div class="contact_bg">
      <div class="link">
        <div>
          <div class="temp1">ZHAOMEIW</div>
          <div class="temp2">联系我们</div>
        </div>
        <div class="temp3"></div>
      </div>
      <div style="width: 1200px;margin:0 auto;padding-top: 50px;">
        <el-carousel height="183px" indicator-position="outside" :autoplay="false">
          <el-carousel-item>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div style="width: 379px;height: 300px;">
                <div class="women"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服1部老师</div>
                    <div style="margin-top: 6px;">17520431609</div>
                  </div>
                </div>
              </div>
              <div style="width: 379px;height: 300px;">
                <div class="women1"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服2部老师</div>
                    <div style="margin-top: 6px;">13544491589</div>
                  </div>
                </div>
              </div>
              <div style="width: 379px;height: 300px;">
                <div class="women2"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服3部老师</div>
                    <div style="margin-top: 6px;">13417986169</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div style="width: 379px;height: 300px;">
                <div class="women3"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服4部老师</div>
                    <div style="margin-top: 6px;">17773555453</div>
                  </div>
                </div>
              </div>
              <div style="width: 379px;height: 300px;">
                <div class="women4"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服5部老师</div>
                    <div style="margin-top: 6px;">18627083529</div>
                  </div>
                </div>
              </div>
              <div style="width: 379px;height: 300px;">
                <div class="women5"></div>
                <div class="service_box" style="margin-top: 50px;">
                  <div class="service_name">
                    <div>客服6部老师</div>
                    <div style="margin-top: 6px;">18902628885</div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 联系我们2 -->
    <div class="contact_bg2">
        <div class="link">
            <div>
            <div class="temp1">ZHAOMEIW</div>
            <div class="temp2">联系我们</div>
            </div>
            <div class="temp3"></div>
        </div>
        <!-- 地图 -->
        <!-- <div class="amap-wrapper" style="margin-top: 28px;">
            <el-amap ref="map" :center="center" :zoom="zoom" :events="events" class="amap-demo">
            <el-amap-marker v-for="(u, index) in markers" :key="index" :position="u.position"></el-amap-marker>
            <el-amap-marker :position="[113.292441,23.030876]"></el-amap-marker>
            <div class="map_left">
                <div class="map_left_img">
                <img src="../../static/img/company/mapstyle.png" alt style="width: 100%;height: 100%;" />
                </div>
                <div class="map_left_text">
                广东省广州市番禺区
                <br />洛浦街道汇南广场东区4楼401
                </div>
            </div>
            </el-amap>
        </div> -->
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  // import { AMapManager } from "vue-amap";  
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        des: require("../../static/img/company/top.png"),
        boss: require("../../static/img/company/boss.jpg"),
        leader: require("../../static/img/company/leader.jpg"),
        scroll100: true,
        scroll: "",
        scroll700: false,
        //高德地图
        // amapManager: new AMapManager(),
        // zoom: 18,//地图缩放级别范围默认[3,18]
        // center: [113.292441, 23.030876],
        // position: [113.292441, 23.030876],
        // icon: '../../static/img/chinese.png',
        events: {
          init: o => {
            console.log(o.getCenter());
            console.log(this.$refs.map.$$getInstance());
            o.getCity(result => {
              console.log(result);
            });
          },
          moveend: () => { },
          zoomchange: () => { },
          click: e => {
            // alert('map clicked');
          }
        },
        // markers: [
        //   {
        //     position: [113.292441, 23.030876]
        //   },
        //   {
        //     position: [113.292441, 23.030876]
        //   }
        // ],
        plugin: [
          "ToolBar",
          {
            pName: "MapType",
            defaultType: 0,
            events: {
              init(o) {
                console.log(o);
              }
            }
          },
          {
            pName: "Scale",
            events: {
              init(instance) {
                console.log(instance);
              }
            }
          }
        ]
      };
    },
    watch: {
      scroll: function () {
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push("/");
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push("./home");
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push("./supplyChain");
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push("./marketingTools");
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push("./company");
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push("./channels");
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push("./contact");
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push("./culture");
      },
      //找美商学院-商学院文化
      goToCollege() {
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli() { 
        this.$router.push("./Ali");
      },
      //找美商学院-行程安排
      gotoTravell() {
        this.$router.push("./Travell");
      },
      //找美商学院-讲师简介
      goToTeach() { },
      //找美商学院-相关案例
      goToCase() { },
      dataScroll(event) {
        this.scroll =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          event.target.scrollTop;
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true;
        } else {
          this.scroll100 = false;
        }
        if (this.scroll > 100) {
          this.scroll700 = true;
        } else {
          this.scroll700 = false;
        }
      }
    },
    created() { },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])
    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url("../../static/img/company/company.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 842px;
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    z-index: 1000;
    position: absolute;
    top: 35%;
    left: 0;
    color: #fff;
    text-align: center;
    min-width: 769px;
    width: 100%;
  }

  .float_container {
    width: 1200px;
    height: 474px;
    display: flex;
    margin: 0 auto;
    box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.07);
  }

  .des {
    width: 474px;
    height: 474px;
  }

  .float_text {
    width: 724px;
    height: 474px;
    background: #fff;
  }

  .introdution {
    margin-top: 91px;
    font-size: 30px;
    color: #000;
    text-align: center;
  }

  .introdution_detail {
    margin: 39px 54px;
    text-indent: 40px;
    font-size: 18px;
    color: #000;
    letter-spacing: 1px;
    line-height: 35px;
  }

  .temp {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    margin-top: 470px;
  }

  .temp1 {
    font-size: 36px;
    font-weight: 800;
    line-height: 54px;
    letter-spacing: 3px;
    color: #343434;
  }

  .temp2 {
    font-size: 26px;
    color: #343434;
    line-height: 37px;
    letter-spacing: 2px;
    margin-top: 11px;
  }

  .temp3 {
    width: 694px;
    height: 2px;
    background: rgba(216, 225, 224, 1);
  }

  .lead {
    width: 1200px;
    display: flex;
    padding-top: 34px;
    padding-bottom: 49px;
    margin: 0 auto;
  }

  .boss_name {
    font-size: 24px;
    color: #222;
  }

  .duty {
    font-size: 12px;
    color: #7a7a7a;
    margin-left: 8px;
  }

  .good_name {
    display: flex;
    align-items: flex-start;
    margin-top: 16px;
  }

  .job {
    font-size: 14px;
    color: #7a7a7a;
  }

  .job_name {
    font-size: 14px;
    color: #222;
  }

  .honors {
    font-size: 14px;
    color: #222;
    width: 492px;
    line-height: 20px;
  }

  .mottos {
    font-size: 14px;
    color: #222;
  }

  .map_container {
    width: 1200px;
    margin: 0 auto;
    height: 549px;
    background-image: url("../../static/img/company/map.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    margin-bottom: 72px;
    margin-top: 28px;
  }

  .map_left {
    background: linear-gradient(180deg,
        rgba(81, 222, 217, 1) 0%,
        rgba(77, 202, 232, 1) 100%);
    width: 202px;
    height: 243px;
    position: absolute;
    top: 0;
    left: 0px;
  }

  .map_left_img {
    width: 174px;
    height: 174px;
    margin: 13px 14px;
    border: none;
    position: relative;
  }

  .map_left_text {
    font-size: 12px;
    line-height: 17px;
    color: #fff;
    /* width: 168px; */
    margin-left: 17px;
    text-indent: 20px;
  }

  .person_con {
    font-size: 14px;
    color: #222;
    width: 494px;
    line-height: 20px;
  }

  .contact_bg {
    width: 100%;
    height: 519px;
    background: rgba(240, 249, 255, 1);
  }

  .link {
    display: flex;
    align-items: center;
    margin: 0 auto;
    padding-top: 97px;
    width: 1200px;
  }

  .service_box {
    background: #e9e9e9;
    width: 379px;
    height: 136px;
  }

  .service_box:hover {
    background: linear-gradient(226deg,
        rgba(81, 223, 216, 1) 0%,
        rgba(77, 202, 232, 1) 100%);
  }

  .amap-demo {
    margin-top: 100px;
    width: 1200px;
    height: 549px;
    margin: 0 auto;
    position: relative;
  }

  .women {
    width: 142px;
    height: 142px;
    position: absolute;
    top: 0px;
    left: 30px;
    z-index: 999;
    opacity: 1;
    background-image: url('../../static/img/company/five.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .women:hover {
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }

  .women1 {
    width: 139px;
    height: 142px;
    position: absolute;
    top: 0px;
    left: 440px;
    z-index: 999;
    background-image: url('../../static/img/company/four.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .women1:hover {
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }
  .women2{
    width: 139px;
    height: 142px;
    position: absolute;
    top:0px;
    right: 210px;
    z-index: 999;
    background-image: url('../../static/img/company/seven.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .women2:hover{
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }
  .women3 {
    width: 142px;
    height: 142px;
    position: absolute;
    top: 0px;
    left: 30px;
    z-index: 999;
    opacity: 1;
    background-image: url('../../static/img/company/one.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .women3:hover {
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }

  .women4 {
    width: 139px;
    height: 142px;
    position: absolute;
    top: 0px;
    left: 440px;
    z-index: 999;
    background-image: url('../../static/img/company/two.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .women4:hover {
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }
  .women5{
    width: 139px;
    height: 142px;
    position: absolute;
    top:0px;
    right: 210px;
    z-index: 999;
    background-image: url('../../static/img/company/three.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .women5:hover{
    width: 142px;
    height: 142px;
    background-image: url('../../static/img/company/ewm.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 999;
  }
  .service_name{
    text-align: center;
    margin-left: 190px;
    padding-top: 28px;
    font-size: 26px;
    color: #000;
  }
</style>


// WEBPACK FOOTER //
// src/page/company.vue